<p>nuevo libro </p>


<label for="">Titulo
<input matInput [(ngModel)]="titulo">
</label>

<label for="">URL
<input matInput [(ngModel)]="url">
</label>
&nbsp;
<button mat-raised-button color="accent" (click)="subirLibro()">Accent</button>

